export * from './src/restaurants-v1-fulfillment-method-fulfillment-methods.universal.js';
